import { Box, Typography, useTheme } from "@mui/material"; // Import Material UI components

// Defining the PositionBadge component with its props
export const PositionBadge: React.FC<{
    name: string, // Name to be displayed
    type: string, // Type to be displayed in bold
    selected?: boolean, // Optional: Indicates if the badge is selected
    disabled?: boolean, // Optional: Indicates if the badge is disabled
    background?: string, // Optional: Background color of the badge
    fontColor?: string, // Optional: Font color of the badge
    onClick?: () => void // Optional: Click handler function
}> = (props) => {
    // Getting the current theme
    const theme = useTheme();

    // Handle click with disabled state check
    const handleClick = () => {
        if (!props.disabled && props.onClick) {
            props.onClick();
        }
    };

    return (
        <Box 
            onClick={handleClick}
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '4px', // Match original padding: 4
                backgroundColor: props.background || theme.palette.background.paper,
                color: props.fontColor || theme.palette.text.primary,
                cursor: props.onClick && !props.disabled ? 'pointer' : 'default',
                borderRadius: '5px', // Match original borderRadius
                margin: '5px', // Match original margin: 15
                boxShadow: theme.shadows[1], // Match original elevation4
                opacity: props.disabled ? 0.5 : 1,
                transition: 'all 150ms ease', // Match original transition timing
                // Selected state styling
                ...(props.selected && {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                }),
                // Hover effect matching original hoverableStackStyles
                '&:hover': props.onClick && !props.disabled ? {
                    boxShadow: theme.shadows[4], // Match original elevation16 on hover
                    transition: 'all 50ms ease', // Match original faster hover transition
                    cursor: 'pointer',
                } : {},
            }}
        >
            <Typography 
                component="p" 
                sx={{ 
                    fontSize: '12px', // Match FontSizes.small (12px) exactly
                    lineHeight: 1.33, // Standard line height for 12px text
                    margin: 0, // Remove default paragraph margins
                }}
            >
                {props.name}{' '}
                <Box component="strong" fontWeight="fontWeightBold">
                    {props.type}
                </Box>
            </Typography>
        </Box>
    );
}; 